import React, { Component } from "react";

import bgimg from "./../../images/main-slider/slide6.jpg";
import video from "./../../images/main-slider/main-slide.mp4";
import logo from "./../../images/logo-color-2.png";

class MainBanner extends Component {
    render() {
        return (
            <div className="home-banner">
                {/* poster shows instantly on every device; the browser swaps to the video
                    automatically once enough of it has loaded (native <video> behaviour,
                    no custom JS needed) - muted+playsInline is allowed to autoplay on mobile too */}
                <video
                    className="banner-video"
                    autoPlay
                    muted
                    loop
                    playsInline
                    poster={bgimg}
                    style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: -2 }}
                >
                    <source src={video} type="video/mp4" />
                </video>
                <div className="home-bnr-inner">
                    <div className="home-bnr-content">
                        <img className="index-logo" src={logo} alt="Rumours Media Logo" />
                    </div>
                </div>
            </div>
        );
    }
}
export default MainBanner;
